"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var styled_components_1 = tslib_1.__importStar(require("styled-components"));
function applySize(_a) {
    var width = _a.width, height = _a.height;
    return styled_components_1.css(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n\t\twidth: ", ";\n\t\theight: ", ";\n\t"], ["\n\t\twidth: ", ";\n\t\theight: ", ";\n\t"])), width + "px", height + "px");
}
var variantStyle = {
    normal: styled_components_1.css(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n\t\tborder-radius: 16px;\n\t"], ["\n\t\tborder-radius: 16px;\n\t"]))),
    circle: styled_components_1.css(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n\t\tborder-radius: 100%;\n\t"], ["\n\t\tborder-radius: 100%;\n\t"]))),
};
function applyVariant(_a) {
    var variant = _a.variant;
    return variantStyle[variant];
}
exports.PhotoImg = styled_components_1.default.img(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n\tborder-radius: 16px;\n\tobject-fit: cover;\n\t", ";\n\t", ";\n"], ["\n\tborder-radius: 16px;\n\tobject-fit: cover;\n\t", ";\n\t", ";\n"])), applyVariant, applySize);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=styled.js.map